<template>
  <div class="status-item">
    <div class="status-item-icon">
      <slot name="icon">
        <img :src="icon" alt="">
      </slot>
    </div>
    <div class="status-item-text">{{ text }}</div>
  </div>
</template>



<script setup>
defineProps({
  text: {
    type: [String, Number],
    default: ''
  },
  icon: {
    type: String,
    default: ''
  }
})
</script>
<style scoped lang="scss">
.status-item {
  display: flex;
  align-items: center;
  gap: 8px;
}

.status-item-icon {
  display: flex;
  align-items: center;
}
</style>
